import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList as ctaModifierList, targetList } from './props-list';

const DEFAULT_CTA_MODIFIERS = ['primary'];
const DEFAULT_TARGET = ['_self'];
const DEFAULT_TAG = 'a';
const DEFAULT_IS_DISABLED = false;
const DEFAULT_ON_CLICK = () => {};

const Cta = ({
  children,
  tag = DEFAULT_TAG,
  id,
  modifiers = DEFAULT_CTA_MODIFIERS,
  href,
  target = DEFAULT_TARGET,
  append,
  prepend,
  intcmpCta,
  disabled = DEFAULT_IS_DISABLED,
  disabledStyle,
  onClick = DEFAULT_ON_CLICK,
}) => {
  let classNames = getClassNames('c-cta', modifiers);
  classNames += disabledStyle ? ' is-disabled' : '';
  const Tag = tag;
  const tagType = tag === 'button' ? 'button' : '';

  return (
    <Tag
      id={id}
      type={tagType}
      className={classNames}
      href={href}
      target={target}
      data-intcmp={intcmpCta}
      onClick={onClick}
      disabled={disabled}
    >
      {prepend}
      <span className="c-cta__text">{children}</span>
      {append}
    </Tag>
  );
};

Cta.propTypes = {
  append: PropTypes.any,
  tag: PropTypes.string,
  children: PropTypes.any.isRequired,
  href: PropTypes.string,
  id: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(ctaModifierList)),
  prepend: PropTypes.any,
  target: PropTypes.oneOf(targetList),
  intcmpCta: PropTypes.string,
  disabled: PropTypes.bool,
  disabledStyle: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Cta;
